import React from 'react';

import {SocialIcon} from './SocialIcon';
import {pushAnalytics} from 'Utils/Analytics';

type SocialBarProps = {};

export const SocialBar: React.StatelessComponent<SocialBarProps> = (props) => {
  const clickHandler = (icon: string, event: React.MouseEvent<HTMLAnchorElement>) => {
    pushAnalytics('social-link', {
      socialNetwork: icon
    });
  };

  return (
    <ul className="social-bar">
      <li>
        <SocialIcon icon="facebook" href="https://www.facebook.com/shawcontractgroup" click={clickHandler} />
      </li>
      <li>
        <SocialIcon icon="twitter" href="https://twitter.com/shawcontract" click={clickHandler} />
      </li>
      <li>
        <SocialIcon icon="pinterest" href="https://www.pinterest.com/shawcontract/" click={clickHandler} />
      </li>
      <li>
        <SocialIcon icon="youtube-play" href="https://www.youtube.com/user/ShawContractGroup1" click={clickHandler} />
      </li>
    </ul>
  );
};
